import React from "react";
import {Link, matchPath, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {
    getAllPathsForRouteKey,
    getLocalizedRoutePath,
    getRouteMatchOptions
} from "../../../routes/definitions";

export default function SidebarButton({
    children,
    path,
    routeKey,
    pathParams,
    fill,
    divClassName,
    onClick,
    matchOptions
}) {
    const location = useLocation();
    const {i18n} = useTranslation();
    const language = i18n.language;

    const targetPath = routeKey
        ? getLocalizedRoutePath(routeKey, language, pathParams)
        : path;

    const resolvedMatchOptions = {
        ...(routeKey ? getRouteMatchOptions(routeKey) : {end: true}),
        ...(matchOptions || {})
    };

    const matchCandidates = routeKey ? getAllPathsForRouteKey(routeKey) : [targetPath];
    const isActive = matchCandidates.some((candidate) =>
        candidate
            ? matchPath(
                {
                    path: candidate,
                    end: resolvedMatchOptions.end,
                    caseSensitive: resolvedMatchOptions.caseSensitive
                },
                location.pathname
            )
            : false
    );

    let className = "flex flex-col items-center ";

    if (!isActive) {
        className += fill
            ? "fill-white transition duration-200 ease-out hover:ease-in h-15 w-15  hover:fill-playmove-yellow"
            : "stroke-white transition duration-200 ease-out hover:ease-in h-15 w-15  hover:stroke-playmove-yellow";
    } else {
        className += fill ? "fill-playmove-yellow" : "stroke-playmove-yellow";
    }

    return (
        <div className={divClassName}>
            {targetPath ? (
                <Link to={targetPath} className={className} onClick={onClick}>
                    {children}
                </Link>
            ) : (
                <div className={className} onClick={onClick}>
                    {children}
                </div>
            )}
        </div>
    );
}
